import { PaginationResponse } from '../types/api/pagination-response'
import { PaginationModel } from '../types/models/pagination.model'

export const paginationResolver = (
  res: PaginationResponse,
): PaginationModel => {
  return {
    currentPage: res.current_page,
    lastPage: res.last_page,
    from: res.from,
    to: res.to,
    limit: res.per_page,
    total: res.total,
    isLast:
      !!res &&
      !!res.last_page &&
      !!res.current_page &&
      res.current_page >= res.last_page,
  }
}
